












import { Component, Vue } from "vue-property-decorator";
import router from "../router";

@Component
export default class NavbarBack extends Vue {
  onBack() {
    router.back();
  }
}
